import $ from 'jquery'

export default {
	twoWay: true,
	params: ['on', 'off', 'onStyle', 'offStyle'],

	bind() {
		$(this.el).bootstrapToggle({
			on: this.params.on,
			off: this.params.off,
			onstyle: this.params.onStyle,
			offstyle: this.params.offStyle
		}).on('change', event => {
			this.set($(event.target).prop('checked'));
		});
	},
	update(newValue, oldValue) {
		if (newValue == 1 || newValue == true) {
			$(this.el).bootstrapToggle('on');
		} else {
			$(this.el).bootstrapToggle('off');
		}
	}
}



// WEBPACK FOOTER //
// ./src/directives/toggle.js